import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function JoinTeamModal({ isOpen, onClose, leagueId }) {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen && leagueId) {
            const fetchTeams = async () => {
                try {
                    setLoading(true);
                    const response = await axios.get(`/api/teams/league/${leagueId}/teams/`, {
                        withCredentials: true,
                    });
                    setTeams(response.data);
                    setError(null);
                } catch (err) {
                    setError('Failed to load teams. Please try again.');
                    console.error('Error fetching teams:', err);
                } finally {
                    setLoading(false);
                }
            };
            fetchTeams();
        }
    }, [isOpen, leagueId]);

    const handleJoinTeam = async (teamId) => {
        try {
            await axios.post(`/api/teams/${teamId}/join/`, {}, {
                withCredentials: true,
            });
            onClose(true); // Pass true to indicate successful join
            navigate(`/teams/${teamId}`); // Navigate to the team page
        } catch (err) {
            setError('Failed to join team. Please try again.');
            console.error('Error joining team:', err);
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
            <div
                className="modal fade show"
                style={{
                    display: 'block',
                    zIndex: 1050,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflow: 'auto'
                }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Join a Team</h5>
                            <button type="button" className="btn-close" onClick={() => onClose(false)}></button>
                        </div>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : error ? (
                                <div className="alert alert-danger">{error}</div>
                            ) : teams.length === 0 ? (
                                <p>No teams are currently available to join.</p>
                            ) : (
                                <div className="list-group">
                                    {teams.map((team) => (
                                        <div key={team.id} className="list-group-item">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center">
                                                    <div className="me-3" style={{ width: '50px', height: '50px' }}>
                                                        {team.logo ? (
                                                            <img
                                                                src={team.logo}
                                                                alt={`${team.name} logo`}
                                                                className="img-fluid rounded"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover'
                                                                }}
                                                            />
                                                        ) : (
                                                            <div
                                                                className="rounded d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    backgroundColor: '#e9ecef',
                                                                    color: '#6c757d'
                                                                }}
                                                            >
                                                                <i className="bi bi-people-fill"></i>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <h6 className="mb-1">{team.name}</h6>
                                                        <small className="text-muted">
                                                            {team.captain ? `Captain: ${team.captain_name}` : 'No captain assigned'}
                                                        </small>
                                                    </div>
                                                </div>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => handleJoinTeam(team.id)}
                                                >
                                                    Join Team
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => onClose(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default JoinTeamModal; 